import myApprovalsListWatcher from './my-approvals/list/saga'
import myApprovalsDetailsWatcher from './my-approvals/view/saga'
import myRequestsWatcher from './my-requests/saga'

export default [myApprovalsListWatcher, myApprovalsDetailsWatcher, myRequestsWatcher]
